export default class Customer{
    constructor(name, surname, phone, email){
        this.name = name;
        this.surname = surname;
        this.phone = phone;
        this.email = email;
    }
}